import { joinPath } from '../../core/utils';
import type { EnvVarsBlockOptions, EnvVarsPaths } from './types';

export function resolveEnvVarsPaths(prefix: string, options?: EnvVarsBlockOptions): EnvVarsPaths {
  const segment = options?.listSegment ?? 'env';
  return { list: joinPath(prefix, segment) };
}
